var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('van-cascader',{attrs:{"title":"请选择所在地区","options":_vm.options,"fieldNames":{
      text: 'name',
      value: 'code',
      children: 'children'
    }},on:{"close":function($event){_vm.visible = false},"finish":_vm.onFinish,"change":_vm.onChange},model:{value:(_vm.cascaderValue),callback:function ($$v) {_vm.cascaderValue=$$v},expression:"cascaderValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }